import { fileResize } from './fileReader';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import React from 'react';

export interface IFileSelectorProps {
    /** Callback once the file is selected.  Passed an object of images in the format key:name_size, value:base_64 data: eg. eventBackground_1024  */
    onFileSelection: Function; //

    /** Callback invoked when there is an error selecting the file.  Passed in a hard-wired error message as an argument (string) */
    onError: Function;

    /** Field name */
    name: string;

    /** Text that appears on the button that opens the file selector */
    buttonLabel: string;

    requiredType?: 'image/jpeg' | 'image/png';
    /** Array of file sizes to return (e.g. ["1024", "150"]) */
    sizes: number[]; //array of file sizes to return

    /** Required dimensions of image.  When present, and condition is not met, error is triggered. */
    required?: {
        width: number;
        height: number;
    }; //required dimensions of input
}

const useStyles = makeStyles(theme => ({
    button: {
        margin: theme.spacing(1),
        color: theme.palette.common.white,
    },
    input: {
        display: 'none',
    },
    formControl: {
        margin: theme.spacing(1),
    },
}));

const FileSelector = ({
    name,
    buttonLabel,
    onError,
    onFileSelection,
    required,
    requiredType,
    sizes,
}: IFileSelectorProps) => {
    const classes = useStyles();
    let images: any;

    const handleSelection = async (evt: React.ChangeEvent<HTMLInputElement>) => {
        //Runs after file is chosen
        const file = (evt.currentTarget.files && evt.currentTarget.files[0]) || null;

        images = sizes.reduce(
            (o, key) => ({
                ...o,
                [key]: null,
            }),
            {},
        );
        Promise.all(
            sizes.map(async size => {
                let r = await fileResize(file, size, size, required, requiredType);
                //Appends current size to name passed in
                // images[name + "_" + size] = r
                images[size] = r;
                return images;
            }),
        )
            .then(data => {
                onFileSelection(images);
            })
            .catch(error => {
                onError('Please ensure your image matches the required dimensions and type!');
            });
    };
    //Helps to ensure prop values are bound to the correct "instance" during runtime
    const buttonId = `${Math.random() * 100}-button}`;

    return (
        <div>
            <input
                name={name}
                onChange={handleSelection}
                accept="image/*"
                className={classes.input}
                id={buttonId}
                multiple
                type="file"
            />
            <label htmlFor={buttonId}>
                <Button color="secondary" variant="contained" component="span" className={classes.button}>
                    {buttonLabel}
                </Button>
            </label>
            {required && (
                <div>
                    Required dimensions are {required.width} x {required.height}
                </div>
            )}
            {requiredType != null && <div>Required filetype is {requiredType}</div>}
        </div>
    );
};

export default FileSelector;
